import { Box, ColorOptions, Spacer, Text } from '@jfs/ui-new'
import { getString } from '../../util/languageStrings'
import { Colors } from '../../util/util'

interface Props {
  allValues?: any
  onPress: any
  email: string
  selectedAppLanguage: string
  textColor?: ColorOptions
}
export const ChangeEmailId = ({ allValues, onPress, email, selectedAppLanguage, textColor = 'PRIMARY' }: Props) => {
  return (
    <Box flexDirection={'row'} align={'center'}>
      <Text
        title={`${email ?? allValues?.email}`}
        color={Colors.BLACK_14 as ColorOptions}
        fontFamily={'JioType-Medium'}
        fontSize={16}
        lineHeight={24}
        testID="mobileNumber"
        letterSpacing={-0.08}
      />
      <Spacer direction={'horizontal'} size={8} />
      <Box h={4} w={4} borderRadius={2} bg={Colors.GREY_BG as ColorOptions} />
      <Spacer direction={'horizontal'} size={8} />
      <Text
        title={getString(selectedAppLanguage, 'change')}
        color={textColor}
        fontFamily={'JioType-Medium'}
        fontSize={14}
        lineHeight={24}
        letterSpacing={-0.07}
        testID={'changeMobileNumber'}
        onPress={onPress}
      />
    </Box>
  )
}
